import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER, MEMBER_SEARCH_VERIFICATION_MODULE } from 'constants/entity-names';
import { isInbound } from 'resolvers/callStateEntities';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc AuthFlowMemberVerificationMemberSearch defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AuthFlowMemberVerificationMemberSearchService } from 'services/authFlowMemberVerificationMemberSearch';
 *
 * // create service instance and send/cancel request
 * const authFlowMemberVerificationMemberSearchService = new AuthFlowMemberVerificationMemberSearchService();
 * const result = await authFlowMemberVerificationMemberSearchService.fetchData( '<user-id>' ); // fetch data
 * authFlowMemberVerificationMemberSearchService.cancel(); // cancel an active request
 */
export class AuthFlowMemberVerificationMemberSearchService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        
        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const module = isInbound() ? MEMBER_SEARCH_VERIFICATION_MODULE.CALLER_VERIFICATION: MEMBER_SEARCH_VERIFICATION_MODULE.CALLEE_VERIFICATION;

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callType,
                        module
                    },
                } ),
            } );

            // component data
            const componentData = get( response, 'body.component', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...componentData,
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // register inbound caller (member)
    async registerInboundCaller( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const module = isInbound() ? MEMBER_SEARCH_VERIFICATION_MODULE.CALLER_VERIFICATION: MEMBER_SEARCH_VERIFICATION_MODULE.CALLEE_VERIFICATION;
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: {
                        callId,
                        callType,
                        module,
                        callerType
                    },
                    data: data,
                },
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: null,
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}

